import { loginStart, loginSuccess, setProfile, loginFailure, logout, sessionRestoreFailure } from './authSlice';
import ApiService from '../services/apiService';
import { API_ROUTES } from '../config/routes';

// Async thunk for login
export const loginUser = (credentials) => async (dispatch) => {
  dispatch(loginStart());
  
  try {
    // Make login API call
    const response = await ApiService.post(API_ROUTES.LOGIN, {
      username: credentials.username,
      password: window.btoa(credentials.password)
    });


    if (response.success) {
      // Try different possible token locations
      const token = response.data?.access_token || 
                   response.data?.token || 
                   response.data?.data?.access_token || 
                   response.data?.data?.token;

      if (token) {
        // Set auth token in ApiService
        ApiService.setAuthToken(token);

        // Dispatch login success
        dispatch(loginSuccess({
          token: token,
          user: response.data?.user || { username: credentials.username }
        }));

        // Fetch user profile
        try {
          const profileResponse = await ApiService.get('/cms/v1/profile');
          if (profileResponse.success) {
            dispatch(setProfile(profileResponse.data));
          }
        } catch (profileError) {
          console.warn('Profile fetch failed:', profileError);
          // Continue even if profile fetch fails
        }

        return { success: true };
      } else {
        dispatch(loginFailure('No authentication token received'));
        return { success: false, error: 'No authentication token received' };
      }
    } else {
      dispatch(loginFailure(response.message || 'Login failed'));
      return { success: false, error: response.message || 'Login failed' };
    }
  } catch (error) {
    console.error('Login error:', error);
    dispatch(loginFailure(error.message || 'An unexpected error occurred'));
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

// Async thunk for logout
export const logoutUser = () => async (dispatch) => {
  try {
    // Clear API service auth
    ApiService.clearAuth();
    
    // Dispatch logout
    dispatch(logout());
    
    return { success: true };
  } catch (error) {
    console.error('Logout error:', error);
    return { success: false, error: error.message };
  }
};

// Async thunk for refreshing profile
export const refreshProfile = () => async (dispatch) => {
  try {
    const profileResponse = await ApiService.get('/cms/v1/profile');
    if (profileResponse.success) {
      dispatch(setProfile(profileResponse.data));
      return { success: true, data: profileResponse.data };
    } else {
      return { success: false, error: profileResponse.message };
    }
  } catch (error) {
    console.error('Profile refresh error:', error);
    return { success: false, error: error.message };
  }
};

// Async thunk for restoring session
export const restoreSession = () => async (dispatch) => {
  const token = localStorage.getItem('authToken');
  
  if (token) {
    // Set auth token in ApiService
    ApiService.setAuthToken(token);
    
    // Try to fetch fresh profile data
    try {
      const profileResponse = await ApiService.get('/cms/v1/profile');
      if (profileResponse.success) {
        dispatch(loginSuccess({
          token: token,
          user: { username: profileResponse.data.username || profileResponse.data.email }
        }));
        dispatch(setProfile(profileResponse.data));
        return { success: true };
      }
    } catch (error) {
      console.warn('Failed to fetch profile, clearing session:', error);
      localStorage.removeItem('authToken');
    }
  }
  
  // No token or failed to validate
  dispatch(sessionRestoreFailure());
  return { success: false };
};